import React from 'react';
import { motion } from 'framer-motion';

export default function AuroraBackground({ variant = 'default' }: { variant?: 'default' | 'subtle' }) {
  const opacity = variant === 'subtle' ? 0.12 : 0.22;
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
      <motion.div
        className="absolute -top-32 -left-32 w-[36rem] h-[36rem] rounded-full blur-3xl"
        style={{ background: `radial-gradient(circle, rgba(242,202,80,${opacity}) 0%, transparent 70%)` }}
        animate={{ x: [0, 40, 0], y: [0, 30, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute top-1/3 -right-40 w-[32rem] h-[32rem] rounded-full blur-3xl"
        style={{ background: `radial-gradient(circle, rgba(153,101,21,${opacity}) 0%, transparent 70%)` }}
        animate={{ x: [0, -30, 0], y: [0, -40, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute bottom-0 left-1/4 w-[28rem] h-[28rem] rounded-full blur-3xl"
        style={{ background: `radial-gradient(circle, rgba(249,228,152,${opacity * 0.8}) 0%, transparent 70%)` }}
        animate={{ x: [0, 20, 0], y: [0, -20, 0] }}
        transition={{ duration: 16, repeat: Infinity, ease: 'easeInOut' }}
      />
    </div>
  );
}
